import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { ConfirmDialog, WarnDialog } from '../../components/shared';
import 'date-fns';
import { TextField, CircularProgress, Backdrop, Box, Button, Card, CardContent, Container, Grid, Dialog, DialogActions, DialogContent, IconButton, Checkbox, ListItem } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import { HtmlTooltip, Typography } from '../../components/controls';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { Calendar } from "mdi-material-ui";
import { Formik, Form, useFormik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { ContentSave, Delete, HelpCircleOutline } from 'mdi-material-ui';
import 'react-medium-image-zoom/dist/styles.css'
import allowAction from '../../helpers/allowAction';
import DateFnsUtils from '@date-io/date-fns';
import { toStringTime, toStringDateTime, toStringDate, toStringDateTimeExternal, convertTime2Date, convertDate2Date } from './../../helpers/date';
import { SET_PLAN_MANAGE_SEARCH, SET_PLAN_DASHBOARD_DATA, SET_PLAN_DASHBOARD_SEARCH } from '../../actions/types';
import { BiDropdownService, BiPlanningService, BiDriverService } from "../../services";
import * as _ from 'lodash';
import TableIcons from '../../materialTableIcons';

const useStyles = makeStyles((theme) => ({
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    formCard: {
        display: 'flex',
        marginTop: 10,
        marginBottom: 10,
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: theme.palette.background.paper,
    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formFieldContainer: {
        display: 'flex',
        width: '25%',
        marginRight: '1rem',
        marginLeft: '1rem',
        marginBottom: 4,
        marginTop: 4
    },
    inputLabel: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    textField: {
        width: 260,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    prefix: {
        width: 100,
        marginRight: 5
    },
    pictureButtonText: {
        color: theme.palette.type === 'light' ? theme.palette.text.secondary : theme.palette.background.paper,
        fontWeight: 'bold'
    },
    validationCondition: {
        textTransform: 'none',
    },
    alertIcon: {
        color: theme.palette.error.main
    },
    checkIcon: {
        color: theme.palette.success.main
    },
    tabCard: {
        display: 'flex',
        marginTop: 6,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary
    },
    saveButton: {
        marginRight: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    deleteButton: {
        marginLeft: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center',
        backgroundColor: theme.palette.error.main,
        color: 'white'
    },
    cancelButton: {
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

const pageCode = "60101";

const filterOptions = createFilterOptions();

export default function PlanCreate(props) {

    const isTransporter = JSON.parse(localStorage.getItem('user'))?.isTransporter === 'T';

    //Loading
    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch();
    const formManageSearch = { ...useSelector((state) => state.planManagement.manageSearch) };
    const formDashboardData = { ...useSelector((state) => state.planManagement.dashboardData) };
    const formDashboardSearch = { ...useSelector((state) => state.planManagement.dashboardSearch) };
    const [formData, setFormData] = useState({ ...useSelector((state) => state.planManagement.dataRow) });
    const isCreatingPlan = isTransporter || (formData && formData.planId === null);
    const isEditingPlan = isTransporter || (formData && typeof formData.planId === 'string');
    const isCompletedWithoutTransporter = formData && formData.state === 'FINISHED';
    const isCompletedWithoutTransporterByStatus = isCompletedWithoutTransporter || (isTransporter && !(formData && ((formData.state === 'PREPARE' && (formData.status === 'OPEN' || formData.status === 'DEFER')) || (formData.state === 'QUEUE' && (formData.status === 'PENDING' || formData.status === 'CHECK-OUT' || formData.status === 'TIMEOUT' || formData.status === 'REJECTED')))));
    const isCompleted = isTransporter || isCompletedWithoutTransporter;
    const isProcessing = isTransporter || isCompleted || (formData && formData.state === 'PROCESS');
    const history = useHistory();
    const classes = useStyles();

    //dropdown
    const [ddlStatus, setDdlStatus] = useState([]);
    const [ddlPlant, setDdlPlant] = useState([]);
    const [ddlUnit, setDdlUnit] = useState([]);
    const [ddlTransport, setDdlTransport] = useState([]);
    const [ddlMaterial, setDdlMaterial] = useState([]);
    const [ddlTruckNo, setDdlTruckNo] = useState([]);
    const [ddlTruckNoByTransport, setDdlTruckNoByTransport] = useState([]);
    const [ddlDriver, setDdlDriver] = useState([]);
    const [ddlDriverByTransport, setDdlDriverByTransport] = useState([]);
    const [ddlMode, setDdlMode] = useState([]);
    const [ddlType, setDdlType] = useState([]);
    const [ddlReferPlan, setDdlReferPlan] = useState([]);
    const [ddlArea, setDdlArea] = useState([]);
    const [ddlPoint, setDdlPoint] = useState([]);
    const [ddlArm, setDdlArm] = useState([]);

    //driver form
    const [adHocDriver, setAdHocDriver] = useState({ isOpen: false, isLoading: false, name: null, phone: null, transport: null, driverId: null, itasId: null, isUpdate: isEditingPlan, titleUpdating: false });
    const [affectedDriver, setAffectedDriver] = useState({});

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });

    const formik = useFormik({
        initialValues: formData,
        onSubmit: async (values) => handleSubmit(values),
    });

    const callFilterOptions = React.useCallback((options, params) => {
        const filtered = filterOptions(options.filter(x => Object.keys(x).filter(n => n !== 'name').length > 0), params);
        if (params.inputValue !== '') {
            filtered.push({
                inputValue: params.inputValue,
                text: `Add "${params.inputValue}"`,
            });
        }
        return filtered;
    }, []);
    const callGetOptionLabel = React.useCallback((option) => {
        if (typeof option === 'string') {
            return option;
        }
        if (option.inputValue) {
            return option.inputValue;
        }
        if (option.hasLine === false) {
            return `# ${option.text}` + (option.driverPhone ? ` (${option.driverPhone})` : '')
        }
        return option.text + (option.driverPhone ? ` (${option.driverPhone})` : '');
    }, []);

    useEffect(() => {
        setFormData({ ...formData, product: formData.product ?? '', materialName: formData.materialName ?? '' });
        //Retreive dropdown
        BiDropdownService.getPlanUnit().then((r) => {
            setDdlUnit(r);
        });
        BiDropdownService.getTicketMode().then((r) => {
            setDdlMode(r);
        });
        BiDropdownService.getTicketType().then((r) => {
            setDdlType(r);
        });
        BiDropdownService.getTicketStatus(formData.ticketId, formData.planId).then((r) => {
            setDdlStatus(r);
        });
        BiDropdownService.getPlant().then((r) => {
            setDdlPlant(r);
        });
        referPlanChange(formData.date);
        setIsLoading(false);
    }, [dispatch]);
    useEffect(() => {
        let plant = formData.plant ?? (ddlPlant.length > 0 ? ddlPlant[0].value : null)
        plantChange(plant);
        setFormData({ ...formData, plant: plant });
    }, [ddlPlant]);
    useEffect(() => {
        let o = handleGetDdlValue(ddlMaterial, formik.values.materialNo);
        if (o === null) {
            //formik.setFieldValue('materialNo', '');
            //formik.setFieldValue('materialName', '');
        } else if (!formik.values.materialName) {
            formik.setFieldValue('materialName', o ? o.name ?? o.text : '');
        }
    }, [ddlMaterial]);
    useEffect(() => {
        areaChange(formik.values.area);
    }, [ddlArea]);
    useEffect(() => {
        pointChange(formik.values.point);
    }, [ddlPoint]);
    useEffect(() => {
        handleSetByTransport(ddlTruckNo, setDdlTruckNoByTransport, formik.values.transportId)
    }, [ddlTruckNo]);
    useEffect(() => {
        handleSetByTransport(ddlDriver, setDdlDriverByTransport, formik.values.transportId)
    }, [ddlDriver]);
    useEffect(() => {
        if (warnDialog.isOpen === false && warnDialog.isSave === true)
            history.push('/planning/plan-management/manage')
    }, [warnDialog]);
    //useEffect(() => {
    //    let o = handleGetDdlValue(ddlArm, formik.values.arm);
    //    if (o === null) {
    //        formik.setFieldValue('arm', '');
    //    }
    //}, [ddlArm]);
    //useEffect(() => {
    //    let o = handleGetDdlValue(ddlTransport, formik.values.transportId);
    //    if (o === null) {
    //        formik.setFieldValue('transportId', '');
    //    }
    //}, [ddlTransport]);
    //useEffect(() => {
    //    let o = handleGetDdlValue(ddlDriver, formik.values.driverId);
    //    if (o === null) {
    //        formik.setFieldValue('driverId', '');
    //    }
    //}, [ddlDriver]);

    const referPlanChange = (date) => {
        if (date)
            BiDropdownService.getPlan(toStringDateTimeExternal(date), formData.ticketId, formData.planId).then((r) => {
                setDdlReferPlan(r);
            });
        else
            setDdlReferPlan([]);
    }

    const pointChange = (value) => {
        let o = handleGetDdlValue(ddlPoint, value);
        if (o === null) {
            //formik.setFieldValue('point', '');
            setDdlArm([]);
        } else {
            BiDropdownService.getArm(formik.values.plant, formik.values.area, o.value).then((r) => {
                setDdlArm(r);
            });
        }
    };
    const areaChange = (value) => {
        let o = handleGetDdlValue(ddlArea, value);
        if (o === null) {
            //formik.setFieldValue('area', '');
            setDdlPoint([]);
        } else {
            BiDropdownService.getPoint(formik.values.plant, o.value).then((r) => {
                setDdlPoint(r);
            });
        }
    };
    const plantChange = (plant) => {
        BiDropdownService.getTransport(plant, formData.ticketId, formData.planId).then((r) => {
            setDdlTransport(r);
        });
        BiDropdownService.getProduct(plant).then((r) => {
            setDdlMaterial(r);
        });
        BiDropdownService.getTruck(plant, formData.ticketId, formData.planId).then((r) => {
            if (ddlTruckNo) {
                let adHoc = ddlTruckNo.filter(v => v.adHoc === true);
                if (adHoc && adHoc.length > 0)
                    setDdlTruckNo([...r, ...adHoc]);
                else
                    setDdlTruckNo(r);
            } else
                setDdlTruckNo(r);
        });
        BiDropdownService.getDriver(plant, formData.ticketId, formData.planId).then((r) => {
            setDdlDriver(r);
        });
        BiDropdownService.getArea(plant).then((r) => {
            setDdlArea(r);
        });
    }

    const handleGetDdlValue = (ddl, value) => {
        if (value) {
            if (ddl && ddl.length > 0)
                for (var i in ddl)
                    if (ddl[i].value === value)
                        return ddl[i];
            //return { text: value, value }
        }
        return null
    }

    const handleSetByTransport = (ddl, set, transportId) => {
        let s = ddl?.filter(v => v.name === transportId) ?? [];
        if (s.length === 0)
            set([])
        else
            set(s)
    }

    const handleAutoCompleteChange = (target, fieldName) => {
        let text;
        let value;
        if (target === null) {
            text = '';
            value = '';
        } else {
            text = target.text
            value = target.value
        }
        let oldValue = formik.values[fieldName];
        formik.setFieldValue(fieldName, value)
        if (fieldName === 'materialNo') {
            text = target?.name ?? text;
            if (formik.values && !formik.values.product) {
                formik.setFieldValue('product', text)
            }
            formik.setFieldValue('materialName', text)
        }
        if (fieldName === 'plant') {
            if (target !== null) {
                plantChange(value);
            }
        }
        if (fieldName === 'area') {
            areaChange(value)
        }
        if (fieldName === 'point') {
            pointChange(value)
        }
        if (fieldName === 'transportId') {
            formik.setFieldValue('transportName', text)
            if (oldValue !== value) {
                formik.setFieldValue('truckNo', '')
                formik.setFieldValue('driverId', '')
            }
            handleSetByTransport(ddlTruckNo, setDdlTruckNoByTransport, value)
            handleSetByTransport(ddlDriver, setDdlDriverByTransport, value)
        }
        if (fieldName === 'driverId') {
            formik.setFieldValue('driverName', text)
            formik.setFieldValue('driverPhone', target?.driverPhone ? target.driverPhone : '')
            formik.setFieldValue('itasId', target?.itasId ? target.itasId : '')
            //
            if (target !== null) {
                let nextMonth = new Date();
                nextMonth.setMonth(nextMonth.getMonth() + 1);
                let msg = '';
                if (target.licenseExpire && new Date(target.licenseExpire) <= nextMonth)
                    msg = `${msg} and licence (${toStringDate(target.licenseExpire)})`;
                if (target.trainingExpire && new Date(target.trainingExpire) <= nextMonth)
                    msg = `${msg} and training (${toStringDate(target.licenseExpire)})`;
                if (msg) {
                    msg = msg.substr(5);
                    setWarnDialog({
                        isOpen: true,
                        title: `Warning`,
                        subTitle: <><Box component="div">'{target.text}' has {msg} expired or in soon</Box></>,
                    })
                }
            }
        }
    };

    const handleSubmit = async (values) => {
        let wrn = '';
        setIsLoading(true)
        if (!formik.values.status)
            wrn = `${wrn}, Status`;
        if (!formik.values.date)
            wrn = `${wrn}, Date`;
        if (!formik.values.plant)
            wrn = `${wrn}, Plant`;
        if (!formik.values.volume)
            wrn = `${wrn}, Volume`;
        if (!formik.values.unit)
            wrn = `${wrn}, Unit`;
        if (!formik.values.transportId)
            wrn = `${wrn}, Transport`;
        if (!formik.values.customerSupplier)
            wrn = `${wrn}, Customer/Supplier`;
        if (!formik.values.materialNo)
            wrn = `${wrn}, Material`;
        if (!formik.values.source)
            wrn = `${wrn}, Source`;
        if (!formik.values.from)
            wrn = `${wrn}, From`;
        if (!formik.values.destination)
            wrn = `${wrn}, Destination`;
        if (!formik.values.to)
            wrn = `${wrn}, To`;
        if (!formik.values.mode)
            wrn = `${wrn}, Mode`;
        if (!formik.values.type)
            wrn = `${wrn}, Type`;
        if (!((!formik.values.truckNo && !formik.values.driverId && !formik.values.bookTime) || (formik.values.truckNo && formik.values.driverId && formik.values.bookTime))) {
            if (!formik.values.truckNo)
                wrn = `${wrn}, Truck No`;
            if (!formik.values.driverId)
                wrn = `${wrn}, Driver`;
            if (!formik.values.bookTime)
                wrn = `${wrn}, Booking Time`;
        }
        if (wrn === '') {
            try {
                //save plan
                let response = await BiPlanningService.savePlanning(values);
                if (response) {
                    if (response.content) {
                        setWarnDialog({
                            isOpen: true,
                            title: `Warning`,
                            subTitle: <><Box component="div">{response.content}</Box></>,
                            isSave: true
                        })
                    } else {
                        history.push('/planning/plan-management/manage')
                    }
                }
            } catch (e) {
                console.log(e.message)
            }
        }
        else {
            wrn = wrn.substr(2);
            setWarnDialog({
                isOpen: true,
                title: `Required`,
                subTitle: <><Box component="div">Please enter {wrn}</Box></>,
            })
        }
        setIsLoading(false)
    }
    const handleCancelPlan = () => {
        dispatch({
            type: SET_PLAN_MANAGE_SEARCH,
            payload: { ...formManageSearch },
        });
        dispatch({
            type: SET_PLAN_DASHBOARD_DATA,
            payload: { ...formDashboardData },
        });
        dispatch({
            type: SET_PLAN_DASHBOARD_SEARCH,
            payload: { ...formDashboardSearch },
        });
        if (formData.backTo === 'dashboard')
            history.push('/planning/plan-management/dashboard')
        else//management
            history.push('/planning/plan-management/manage')
    }
    const handleDeletePlan = async () => {
        setConfirmDialog({
            isOpen: true,
            title: `Confirm`,
            subTitle: <><Box component="div">{`Are you sure you want to delete ${formData?.ticketId} from the system?`}</Box></>,
            onConfirm: async () => {
                try {
                    let response = await BiPlanningService.removePlan(formData?.planId)
                    if (response)
                        history.push('/planning/plan-management/manage')
                } catch (e) {
                    console.log(e.message)
                }
                setConfirmDialog({ ...confirmDialog, isOpen: false })
            }
        })
    }

    const handleSaveAdHocDriver = () => {
        setAdHocDriver({ ...adHocDriver, isLoading: true });
        if (!(adHocDriver.name && adHocDriver.phone && adHocDriver.transport?.value)) {
            setWarnDialog({
                isOpen: true,
                title: `Required`,
                subTitle: <><Box component="div">Please input value</Box></>,
            })
        } else {
            let task = adHocDriver.driverId ? BiDriverService.updateAdHoc(adHocDriver.driverId, adHocDriver.name, adHocDriver.phone, adHocDriver.transport?.value) : BiDriverService.saveAdHoc(adHocDriver.name, adHocDriver.phone, adHocDriver.transport?.value);
            task.then((r) => {
                if (r) {
                    formik.setFieldValue('driverId', r.driverId)
                    formik.setFieldValue('driverName', r.name)
                    formik.setFieldValue('driverPhone', r.phone ?? adHocDriver.phone)
                    formik.setFieldValue('itasId', adHocDriver.itasId)
                    let v = { value: r.driverId, text: r.name, name: adHocDriver.transport?.value, hasLine: false, driverPhone: r.phone ?? adHocDriver.phone, itasId: adHocDriver.itasId };
                    if (ddlDriver && ddlDriver.length > 0) {
                        setDdlDriver([...ddlDriver.filter(x => x.value !== r.driverId), v]);
                    } else {
                        setDdlDriver([v]);
                    }
                    if (ddlDriverByTransport && ddlDriverByTransport.length > 0) {
                        setDdlDriverByTransport([...ddlDriverByTransport.filter(x => x.value !== r.driverId), v])
                    } else {
                        setDdlDriverByTransport([v])
                    }
                    setAdHocDriver({ ...adHocDriver, isOpen: false });
                    let names = Object.keys(affectedDriver);
                    names.map((editData) => {
                        affectedDriver[editData](r);
                        delete affectedDriver[editData];
                        setAffectedDriver({ ...affectedDriver });
                    });
                }
            });
        }
        setAdHocDriver({ ...adHocDriver, isLoading: false });
    }

    //if page reload, send user back to home
    if (!isEditingPlan && !isCreatingPlan) {
        history.push('/planning/plan-management/manage')
    }

    return (
        <>
            <Backdrop className={classes.backdrop} open={isLoading} timeout={{ enter: 1100 }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        {isTransporter ? <>Plan Detail</> : (isCreatingPlan ? <> Create New Plan </> : <> Edit Plan </>)}
                    </h2>
                </div>

                <Grid container spacing={3}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 10, marginBottom: 10 }}>
                        {(!isTransporter && !isCompleted && allowAction(pageCode, "edit")) || (isTransporter && !isCompletedWithoutTransporterByStatus) ?
                            <Button className={classes.saveButton} startIcon={<ContentSave />} onClick={formik.handleSubmit} size='small' variant='contained' color='primary'>
                                Save
                            </Button>
                            : null}
                        <Button className={classes.cancelButton} onClick={handleCancelPlan} size='small' variant='contained' color='default'>
                            Cancel
                        </Button>
                        {!isCompleted && isEditingPlan && allowAction(pageCode, "delete") ?
                            <Button className={classes.deleteButton} startIcon={<Delete style={{ color: 'white' }} />} onClick={handleDeletePlan} size='small' variant='contained'>
                                Delete
                            </Button>
                            : ''}
                    </div>
                </Grid>

                <br />

                <Grid item xs={12}>
                    <Card className={classes.card}>
                        <Formik>
                            <Form onSubmit={formik.onSubmit}>
                                <CardContent>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Grid container spacing={3}>

                                            {/*ticket id*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Ticket Id"
                                                    placeholder="(auto)"
                                                    disabled={true}
                                                    fullWidth
                                                    value={formik.values.ticketId}
                                                    id="ticketId"
                                                    name="ticketId"
                                                    size="small"
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true, style: { color: formik.values.fastTrack ? 'red' : (formik.values.createType === 'IMPORT' ? 'black' : 'blue') } }}
                                                />
                                            </Grid>

                                            {/*status*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="status"
                                                    name="status"
                                                    disabled={isCompleted}
                                                    closeIcon=""
                                                    options={ddlStatus}
                                                    value={handleGetDdlValue(ddlStatus, formik.values.status)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'status')}
                                                    renderInput={(params) => <TextField {...params}
                                                        size="small"
                                                        variant="outlined"
                                                        label="Status"
                                                        required
                                                        error={formik.touched.status && Boolean(formik.errors.status)}
                                                        helperText={formik.touched.status && formik.errors.status}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*date*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <Grid container justify="space-around">
                                                        <KeyboardDatePicker
                                                            id="date"
                                                            name="date"
                                                            disableToolbar={false}
                                                            disabled={isCompletedWithoutTransporterByStatus}
                                                            autoOk={true}
                                                            size="small"
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="dd-MMM-yyyy"
                                                            label="Date"
                                                            value={convertDate2Date(formik.values.date)}
                                                            onChange={(d) => { formik.setFieldValue('date', toStringDateTimeExternal(d)); referPlanChange(d); }}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change date',
                                                            }}
                                                            required
                                                            ampm={false}
                                                            keyboardIcon={<Calendar />}
                                                            error={formik.touched.date && Boolean(formik.errors.date)}
                                                            helperText={formik.touched.date && formik.errors.date}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>
                                            </Grid>

                                            {/*plant*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="plant"
                                                    name="plant"
                                                    closeIcon=""
                                                    disabled={isCompleted || (isEditingPlan ? true : false)}
                                                    options={ddlPlant}
                                                    value={handleGetDdlValue(ddlPlant, formik.values.plant)}
                                                    getOptionLabel={(option) => option.text ? option.text : ''}
                                                    getOptionSelected={(option, value) => option.value === value.value}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'plant')}
                                                    onBlur={e => {
                                                        if (!e.target.value && ddlPlant.length > 0) {
                                                            setWarnDialog({
                                                                isOpen: true,
                                                                title: `Invalid`,
                                                                subTitle: <><Box component="div">Plant can't empty</Box></>,
                                                            });
                                                            e.target.focus();
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="plant"
                                                        name="plant"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Plant"
                                                        required
                                                        error={formik.touched.plant && Boolean(formik.errors.plant)}
                                                        helperText={formik.touched.plant && formik.errors.plant}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*volume*/}
                                            <Grid item xs={6} sm={6} md={2} lg={2}>
                                                <TextField
                                                    label="Volume"
                                                    required
                                                    fullWidth
                                                    disabled={isCompleted}
                                                    value={formik.values.volume}
                                                    onChange={e => { if (!isNaN(Number(e.target.value))) formik.handleChange(e) }}
                                                    id="volume"
                                                    name="volume"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 15 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*unit*/}
                                            <Grid item xs={6} sm={6} md={2} lg={2}>
                                                <Autocomplete
                                                    id="unit"
                                                    name="unit"
                                                    disabled={isCompleted}
                                                    closeIcon=""
                                                    options={ddlUnit}
                                                    value={handleGetDdlValue(ddlUnit, formik.values.unit)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'unit')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="unit"
                                                        name="unit"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Unit"
                                                        required
                                                        error={formik.touched.unit && Boolean(formik.errors.unit)}
                                                        helperText={formik.touched.unit && formik.errors.unit}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*density*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    fullWidth
                                                    disabled={isCompleted}
                                                    value={formik.values.density}
                                                    onChange={e => { if (!isNaN(Number(e.target.value))) formik.handleChange(e) }}
                                                    id="density"
                                                    name="density"
                                                    size="small"
                                                    variant="outlined"
                                                    label="Density"
                                                    inputProps={{ maxLength: 13 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*transporter*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="transportId"
                                                    name="transportId"
                                                    disabled={isCompleted || (isEditingPlan && formik.values.transportId ? true : false)}
                                                    closeIcon=""
                                                    options={ddlTransport}
                                                    value={handleGetDdlValue(ddlTransport, formik.values.transportId)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'transportId')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="transportId"
                                                        name="transportId"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Transport"
                                                        required
                                                        error={formik.touched.transportId && Boolean(formik.errors.transportId)}
                                                        helperText={formik.touched.transportId && formik.errors.transportId}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*customer supplier*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Customer/Supplier"
                                                    required
                                                    disabled={isCompleted}
                                                    fullWidth
                                                    value={formik.values.customerSupplier}
                                                    onChange={formik.handleChange}
                                                    id='customerSupplier'
                                                    name='customerSupplier'
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*batch no*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    disabled={isCompleted}
                                                    fullWidth
                                                    label="Batch No"
                                                    value={formik.values.batchNo}
                                                    onChange={formik.handleChange}
                                                    id="batchNo"
                                                    name="batchNo"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*product*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Product"
                                                    disabled={isCompleted}
                                                    fullWidth
                                                    value={formik.values.product}
                                                    onChange={formik.handleChange}
                                                    id="product"
                                                    name="product"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*material no*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="materialNo"
                                                    name="materialNo"
                                                    disabled={isCompleted}
                                                    closeIcon=""
                                                    options={ddlMaterial}
                                                    value={handleGetDdlValue(ddlMaterial, formik.values.materialNo)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'materialNo')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="materialNo"
                                                        name="materialNo"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Material No"
                                                        required
                                                        error={formik.touched.materialNo && Boolean(formik.errors.materialNo)}
                                                        helperText={formik.touched.materialNo && formik.errors.materialNo}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*material name*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Material Name"
                                                    disabled={true}
                                                    fullWidth
                                                    value={formik.values.materialName}
                                                    id="materialName"
                                                    name="materialName"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*source*/}
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <TextField
                                                    label="Source"
                                                    required
                                                    disabled={isCompleted}
                                                    fullWidth
                                                    value={formik.values.source}
                                                    onChange={formik.handleChange}
                                                    id="source"
                                                    name="source"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*from*/}
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <TextField
                                                    label="From"
                                                    required
                                                    disabled={isCompleted}
                                                    fullWidth
                                                    value={formik.values.from}
                                                    onChange={formik.handleChange}
                                                    id="from"
                                                    name="from"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*destination*/}
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <TextField
                                                    label="Destination"
                                                    required
                                                    fullWidth
                                                    disabled={isCompleted}
                                                    value={formik.values.destination}
                                                    onChange={formik.handleChange}
                                                    id="destination"
                                                    name="destination"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*to*/}
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <TextField
                                                    label="To"
                                                    required
                                                    fullWidth
                                                    disabled={isCompleted}
                                                    value={formik.values.to}
                                                    onChange={formik.handleChange}
                                                    id="to"
                                                    name="to"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*so*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Sales Order"
                                                    fullWidth
                                                    disabled={isCompleted}
                                                    value={formik.values.so}
                                                    onChange={formik.handleChange}
                                                    id="so"
                                                    name="so"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*do*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Delivery Order"
                                                    fullWidth
                                                    disabled={isCompleted}
                                                    value={formik.values.do}
                                                    onChange={formik.handleChange}
                                                    id="do"
                                                    name="do"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50 }}
                                                    InputLabelProps={{ shrink: true }}
                                                    />
                                            </Grid>

                                            {/*po*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <TextField
                                                    label="Purchase Order"
                                                    disabled={isCompletedWithoutTransporterByStatus}
                                                    fullWidth
                                                    value={formik.values.po}
                                                    onChange={formik.handleChange}
                                                    id="po"
                                                    name="po"
                                                    size="small"
                                                    variant="outlined"
                                                    inputProps={{ maxLength: 50, classes: { notchedOutline: { borderColor: 'red !important' } } }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*truck no*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    filterOptions={callFilterOptions}
                                                    getOptionLabel={callGetOptionLabel}
                                                    onChange={(event, newValue) => {
                                                        let v, t;
                                                        let isAlert = true;
                                                        let testFormat = v => /^((.{2}\.\d{2,3}-\d{4}(\/((.{2}\.)?\d{2,3}-)\d{4})?)|(.{2}\.\d{0,1}.{2}\d{1,4}))$/.test(v);
                                                        if (typeof newValue === 'string') {
                                                            if (testFormat(newValue.trim())) {
                                                                isAlert = false;
                                                                setTimeout(() => {
                                                                    if (formik.values.transportId) {
                                                                        t = handleGetDdlValue(ddlTransport, formik.values.transportId)
                                                                        v = { text: newValue.trim(), value: newValue.trim(), name: t?.value, adHoc: true }
                                                                        if (ddlTruckNo && ddlTruckNo.length > 0) {
                                                                            setDdlTruckNo([...ddlTruckNo, v])
                                                                        } else {
                                                                            setDdlTruckNo([v])
                                                                        }
                                                                        if (ddlTruckNoByTransport && ddlTruckNoByTransport.length > 0) {
                                                                            setDdlTruckNoByTransport([...ddlTruckNoByTransport, v])
                                                                        } else {
                                                                            setDdlTruckNoByTransport([v])
                                                                        }
                                                                        //to do : insert new truck
                                                                        handleAutoCompleteChange(v, 'truckNo')
                                                                    } else {
                                                                        setWarnDialog({
                                                                            isOpen: true,
                                                                            title: `Warning`,
                                                                            subTitle: <><Box component="div">Please choose Transport first</Box></>,
                                                                        })
                                                                    }
                                                                });
                                                            }
                                                        } else if (newValue && newValue.inputValue) {
                                                            if (testFormat(newValue.inputValue.trim())) {
                                                                isAlert = false;
                                                                if (formik.values.transportId) {
                                                                    t = handleGetDdlValue(ddlTransport, formik.values.transportId)
                                                                    v = { text: newValue.inputValue.trim(), value: newValue.inputValue.trim(), name: t?.value, adHoc: true }
                                                                    if (ddlTruckNo && ddlTruckNo.length > 0) {
                                                                        setDdlTruckNo([...ddlTruckNo, v])
                                                                    } else {
                                                                        setDdlTruckNo([v])
                                                                    }
                                                                    if (ddlTruckNoByTransport && ddlTruckNoByTransport.length > 0) {
                                                                        setDdlTruckNoByTransport([...ddlTruckNoByTransport, v])
                                                                    } else {
                                                                        setDdlTruckNoByTransport([v])
                                                                    }
                                                                    //to do : insert new truck
                                                                    handleAutoCompleteChange(v, 'truckNo')
                                                                } else {
                                                                    setWarnDialog({
                                                                        isOpen: true,
                                                                        title: `Warning`,
                                                                        subTitle: <><Box component="div">Please choose Transport first</Box></>,
                                                                    })
                                                                }
                                                            }
                                                        } else {
                                                            isAlert = false;
                                                            handleAutoCompleteChange(newValue, 'truckNo')
                                                        }
                                                        if (isAlert) {
                                                            setWarnDialog({
                                                                isOpen: true,
                                                                title: `Warning`,
                                                                subTitle: <><Box component="div">Invalid Truck No : [หัว] กก.12-1234 หรือ [หัว/หาง] กก.12-1234/98-7654, กก.12-1234/กก.98-7654 หรือ [กระบะ] กก.1กก1234</Box></>,
                                                            })
                                                        }
                                                    }}
                                                    selectOnFocus
                                                    clearOnBlur
                                                    handleHomeEndKeys
                                                    disabled={isCompletedWithoutTransporterByStatus}
                                                    id="truckNo"
                                                    name="truckNo"
                                                    closeIcon=""
                                                    options={ddlTruckNoByTransport}
                                                    value={handleGetDdlValue(ddlTruckNo, formik.values.truckNo)}
                                                    //getOptionLabel={(option) => option.text ? option.text : ''}
                                                    getOptionSelected={(option, value) => option.value === value.value}
                                                    renderOption={option => <>{option.text}</>}
                                                    //onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'truckNo')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="truckNo"
                                                        name="truckNo"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Truck No"
                                                        error={formik.touched.truckNo && Boolean(formik.errors.truckNo)}
                                                        helperText={formik.touched.truckNo && formik.errors.truckNo}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*driver*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <ListItem alignItems="center" style={{ padding: 'unset' }}>
                                                    <Autocomplete
                                                        filterOptions={callFilterOptions}
                                                        getOptionLabel={callGetOptionLabel}
                                                        onChange={(event, newValue) => {
                                                            if (typeof newValue === 'string') {
                                                                if (newValue.trim().length > 4 && newValue.trim().length <= 50) {
                                                                    setTimeout(() => {
                                                                        let v = handleGetDdlValue(ddlTransport, formik.values.transportId)
                                                                        setAdHocDriver({ ...adHocDriver, isOpen: true, name: newValue, phone: '', transport: v, isUpdate: false, driverId: null, itasId: null, titleUpdating: false });
                                                                        setAffectedDriver({
                                                                            ...affectedDriver,
                                                                            [formik.values.planId ?? '-']: (driver) => {
                                                                                handleAutoCompleteChange({ text: driver ? driver.name : '', value: driver ? driver.driverId : '', name: v?.value, hasLine: v?.hasLine ?? driver?.hasLine ?? false, driverPhone: driver?.phone, itasId: driver?.itasId }, 'driverId')
                                                                            }
                                                                        })
                                                                    });
                                                                } else {
                                                                    setWarnDialog({
                                                                        isOpen: true,
                                                                        title: `Warning`,
                                                                        subTitle: <><Box component="div">Driver Name too short/long</Box></>,
                                                                    })
                                                                }
                                                            } else if (newValue && newValue.inputValue) {
                                                                if (newValue.inputValue.trim().length > 4 && newValue.inputValue.trim().length <= 50) {
                                                                    let v = handleGetDdlValue(ddlTransport, formik.values.transportId)
                                                                    setAdHocDriver({ ...adHocDriver, isOpen: true, name: newValue.inputValue, phone: '', transport: v, isUpdate: false, driverId: null, itasId: null, titleUpdating: false });
                                                                    setAffectedDriver({
                                                                        ...affectedDriver,
                                                                        [formik.values.planId ?? '-']: (driver) => {
                                                                            handleAutoCompleteChange({ text: driver ? driver.name : '', value: driver ? driver.driverId : '', name: v?.value, hasLine: v?.hasLine ?? driver?.hasLine ?? false, driverPhone: driver?.phone, itasId: driver?.itasId }, 'driverId')
                                                                        }
                                                                    })
                                                                } else {
                                                                    setWarnDialog({
                                                                        isOpen: true,
                                                                        title: `Warning`,
                                                                        subTitle: <><Box component="div">Driver Name too short/long</Box></>,
                                                                    })
                                                                }
                                                            } else {
                                                                handleAutoCompleteChange(newValue, 'driverId')
                                                            }
                                                        }}
                                                        fullWidth
                                                        selectOnFocus
                                                        clearOnBlur
                                                        handleHomeEndKeys
                                                        id="driverId"
                                                        name="driverId"
                                                        disabled={isCompletedWithoutTransporterByStatus}
                                                        closeIcon=""
                                                        options={ddlDriverByTransport}
                                                        value={handleGetDdlValue(ddlDriver, formik.values.driverId)}
                                                        renderOption={option => <><Box component="span" style={{ 'color': 'red' }}>{option?.hasLine ? null : '#'}</Box><Box component="span">{option?.text}</Box><Box component="span">{(option?.driverPhone ? ` (${option.driverPhone})` : '')}</Box></>}
                                                        //onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'driverId')}
                                                        renderInput={(params) => <TextField {...params}
                                                            id="driverId"
                                                            name="driverId"
                                                            size="small"
                                                            variant="outlined"
                                                            label="Driver [# ยังไม่ได้ลงทะเบียน]"
                                                            error={formik.touched.driverId && Boolean(formik.errors.driverId)}
                                                            helperText={formik.touched.driverId && formik.errors.driverId}
                                                            InputLabelProps={{ shrink: true }}
                                                        />}
                                                    />
                                                    {formik.values.driverId && !formik.values.itasId//adHocDriver.isUpdate && 
                                                        ?
                                                        <IconButton aria-label="settings" onClick={() => {
                                                            let v = handleGetDdlValue(ddlTransport, formik.values.transportId)
                                                            setAdHocDriver({ ...adHocDriver, isOpen: true, name: formik.values.driverName, phone: formik.values.driverPhone, transport: v, isUpdate: true, driverId: formik.values.driverId, itasId: formik.values.itasId, titleUpdating: true });
                                                        }}>
                                                            <TableIcons.Edit />
                                                        </IconButton>
                                                        :
                                                        <></>
                                                    }
                                                </ListItem>
                                            </Grid>

                                            {/*booking time*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <Grid container justify="space-around">
                                                        <KeyboardTimePicker
                                                            //disableOpenOnEnter
                                                            id="bookTime"
                                                            name="bookTime"
                                                            label="Booking Time"
                                                            disabled={isCompletedWithoutTransporterByStatus}
                                                            mask="__:__"
                                                            disableToolbar
                                                            autoOk={true}
                                                            size="small"
                                                            fullWidth
                                                            inputVariant="outlined"
                                                            format="HH:mm"
                                                            value={convertTime2Date(formik.values.bookTime) ?? null}
                                                            onChange={d => { let v = toStringTime(d); formik.setFieldValue('bookTime', /(([01][0-9])|(2[0123])):([012345][0-9])/.test(v) ? v : null); }}
                                                            onBlur={e => {
                                                                if (e.target.value) {
                                                                    if (!/(([01][0-9])|(2[0123])):([012345][0-9])/.test(e.target.value)) {
                                                                        setWarnDialog({
                                                                            isOpen: true,
                                                                            title: `Invalid`,
                                                                            subTitle: <><Box component="div">Invalid format time</Box></>,
                                                                        })
                                                                        e.target.focus();
                                                                    }
                                                                }
                                                            }}
                                                            KeyboardButtonProps={{
                                                                'aria-label': 'change time',
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </Grid>
                                                </MuiPickersUtilsProvider>
                                            </Grid>

                                            {/*mode*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="mode"
                                                    name="mode"
                                                    disabled={isCompleted}
                                                    closeIcon=""
                                                    options={ddlMode}
                                                    value={handleGetDdlValue(ddlMode, formik.values.mode)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'mode')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="mode"
                                                        name="mode"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Mode"
                                                        required
                                                        error={formik.touched.mode && Boolean(formik.errors.mode)}
                                                        helperText={formik.touched.mode && formik.errors.mode}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*type*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="type"
                                                    name="type"
                                                    disabled={isCompleted}
                                                    closeIcon=""
                                                    options={ddlType}
                                                    value={handleGetDdlValue(ddlType, formik.values.type)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'type')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="type"
                                                        name="type"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Type"
                                                        required
                                                        error={formik.touched.type && Boolean(formik.errors.type)}
                                                        helperText={formik.touched.type && formik.errors.type}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*reference plan*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="referencePlanId"
                                                    name="referencePlanId"
                                                    disabled={isCompleted}
                                                    closeIcon=""
                                                    options={ddlReferPlan}
                                                    value={handleGetDdlValue(ddlReferPlan, formik.values.referencePlanId)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'referencePlanId')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="referencePlanId"
                                                        name="referencePlanId"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Reference Plan"
                                                        error={formik.touched.referencePlanId && Boolean(formik.errors.referencePlanId)}
                                                        helperText={formik.touched.referencePlanId && formik.errors.referencePlanId}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*remark*/}
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <TextField
                                                    disabled={isCompleted}
                                                    fullWidth
                                                    value={formik.values.remark}
                                                    onChange={formik.handleChange}
                                                    id="remark"
                                                    name="remark"
                                                    size="small"
                                                    variant="outlined"
                                                    label="Remark"
                                                    inputProps={{ maxLength: 150 }}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/*area*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="area"
                                                    name="area"
                                                    disabled={isProcessing}
                                                    closeIcon=""
                                                    options={ddlArea}
                                                    value={handleGetDdlValue(ddlArea, formik.values.area)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'area')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="area"
                                                        name="area"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Area"
                                                        error={formik.touched.area && Boolean(formik.errors.area)}
                                                        helperText={formik.touched.area && formik.errors.area}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*point*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="point"
                                                    name="point"
                                                    disabled={isProcessing}
                                                    closeIcon=""
                                                    options={ddlPoint}
                                                    value={handleGetDdlValue(ddlPoint, formik.values.point)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'point')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="point"
                                                        name="point"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Point"
                                                        error={formik.touched.point && Boolean(formik.errors.point)}
                                                        helperText={formik.touched.point && formik.errors.point}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {/*arm*/}
                                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                                <Autocomplete
                                                    id="arm"
                                                    name="arm"
                                                    disabled={isProcessing}
                                                    closeIcon=""
                                                    options={ddlArm}
                                                    value={handleGetDdlValue(ddlArm, formik.values.arm)}
                                                    getOptionLabel={(option) => option.text}
                                                    renderOption={option => <>{option.text}</>}
                                                    onChange={(event, newValue) => handleAutoCompleteChange(newValue, 'arm')}
                                                    renderInput={(params) => <TextField {...params}
                                                        id="arm"
                                                        name="arm"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Arm"
                                                        error={formik.touched.arm && Boolean(formik.errors.arm)}
                                                        helperText={formik.touched.arm && formik.errors.arm}
                                                        InputLabelProps={{ shrink: true }}
                                                    />}
                                                />
                                            </Grid>

                                            {isEditingPlan ? <>

                                                {/*fast track*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <ListItem alignItems="center" style={{ padding: 'unset' }}>
                                                        <Checkbox
                                                            inputProps={{ "aria-label": "primary checkbox" }}
                                                            disabled={isCompleted}
                                                            name='cFastTrack'
                                                            id='cFastTrack'
                                                            checked={formik.values.fastTrack ? true : false}
                                                            color='primary'
                                                            onChange={e => formik.setFieldValue('fastTrack', e.target.checked ? toStringDateTimeExternal(new Date()) : null)}
                                                        />
                                                        <TextField
                                                            disabled={true}
                                                            fullWidth
                                                            value={formik.values.fastTrack ? toStringDateTime(formik.values.fastTrack) : ''}
                                                            id="fastTrack"
                                                            name="fastTrack"
                                                            size="small"
                                                            variant="outlined"
                                                            label="Fast Track Time"
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    </ListItem>
                                                </Grid>

                                                {/*queue time*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={toStringDateTime(formik.values.queueTime)}
                                                        id="queueTime"
                                                        name="queueTime"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Queue Time"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                {/*actual start*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={toStringDateTime(formik.values.actualStartDate)}
                                                        id="actaulStartDate"
                                                        name="actaulStartDate"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Actual Start"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                {/*actual completed*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={toStringDateTime(formik.values.actualCompletedDate)}
                                                        id="actualCompletedDate"
                                                        name="actualCompletedDate"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Actual Completed"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                {/*create by*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={formik.values.createBy}
                                                        id="createBy"
                                                        name="createBy"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Create By"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                {/*create date*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={toStringDateTime(formik.values.createDate)}
                                                        id="createDate"
                                                        name="createDate"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Create Date"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                {/*modify by*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={formik.values.modifyBy}
                                                        id="modifyBy"
                                                        name="modifyBy"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Modify By"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                                {/*modify date*/}
                                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                                    <TextField
                                                        disabled={true}
                                                        fullWidth
                                                        value={toStringDateTime(formik.values.modifyDate)}
                                                        id="modifyDate"
                                                        name="modifyDate"
                                                        size="small"
                                                        variant="outlined"
                                                        label="Modify Date"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>

                                            </>
                                                : null}

                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Form>
                        </Formik>
                    </Card>
                </Grid>
            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <Backdrop className={classes.backdrop} open={!formik.values}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/*New Driver*/}
            <Dialog
                fullWidth={false}
                maxWidth={'lg'}
                open={adHocDriver.isOpen}
                onClose={() => setAdHocDriver({ ...adHocDriver, isOpen: false })}
                aria-labelledby="form-dialog-title">
                <DialogContent id="form-dialog-title" style={{ minHeight: '220px' }}>
                    <Grid container>
                        <Grid item xs={6}>
                            <b>{adHocDriver.titleUpdating ? "Edit Driver" : "Create One Time Driver"}</b>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                            <HtmlTooltip title={
                                <React.Fragment>
                                    <Typography color="inherit">One Time Driver</Typography>
                                    <span>Partner driver, please create on ITAS</span>
                                </React.Fragment>
                            }>
                                <IconButton aria-label="settings">
                                    <HelpCircleOutline />
                                </IconButton>
                            </HtmlTooltip>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Grid container spacing={1}>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <TextField
                                        id="newDriverName"
                                        name="newDriverName"
                                        label="Name"
                                        className={classes.textField}
                                        variant='outlined'
                                        size="small"
                                        inputProps={{ maxLength: 50 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={adHocDriver.name}
                                        onChange={(ev) => setAdHocDriver({ ...adHocDriver, name: ev.target.value })}
                                        onBlur={(ev) => setAdHocDriver({ ...adHocDriver, name: ev.target.value.trim().length > 2 ? ev.target.value.trim() : '' })}
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <TextField
                                        id="newDriverPhone"
                                        name="newDriverPhone"
                                        label="Phone"
                                        className={classes.textField}
                                        variant='outlined'
                                        size="small"
                                        inputProps={{ maxLength: 10 }}
                                        InputLabelProps={{ shrink: true }}
                                        value={adHocDriver.phone}
                                        onChange={(ev) => { if (ev.target.value === '' || /^0[0-9\b]{0,9}$/.test(ev.target.value)) setAdHocDriver({ ...adHocDriver, phone: ev.target.value }); }}
                                        onBlur={(ev) => setAdHocDriver({ ...adHocDriver, phone: (ev.target.value === '' || /^0[1-9\b]{1}[0-9\b]{8}$/.test(ev.target.value)) ? ev.target.value : '' })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Autocomplete
                                        id="newDriverTransport"
                                        name="newDriverTransport"
                                        options={ddlTransport}
                                        value={adHocDriver.transport}
                                        disabled={adHocDriver.isUpdate}
                                        getOptionLabel={(option) => option.text}
                                        getOptionSelected={(option, value) => option.text === value.text}
                                        getOptionDisabled={(option) => option.value === ""}
                                        renderOption={option => <>{option.text}</>}
                                        onChange={(event, newValue) => setAdHocDriver({ ...adHocDriver, transport: newValue })}
                                        renderInput={(params) => <TextField {...params}
                                            id="newDriverTransportText"
                                            name="newDriverTransportText"
                                            label="Transport"
                                            size="small"
                                            variant="outlined"
                                        />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <div className={classes.buttonWrapper}>
                        <Button disabled={adHocDriver.isLoading} onClick={handleSaveAdHocDriver} variant="contained" color="primary">Save</Button>
                        {adHocDriver.isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                    <Button onClick={() => setAdHocDriver({ ...adHocDriver, isOpen: false })} variant="contained">Cancel</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};